import "./AboutMe.css";
import { motion } from 'framer-motion';
import Companies from "./projects/components/Companies";
import GrainOverlay from '../GrainOverlay';
import { staggerContainer, fadeUp, fadeIn } from '../motionVariants';

const AboutMe = ({ scrollToWork }) => {
    return (
        <section className="AboutMe">
            {/* Animated mesh gradient background */}
            <div className="hero-mesh" aria-hidden="true">
                <div className="hero-blob hero-blob-1" />
                <div className="hero-blob hero-blob-2" />
                <div className="hero-blob hero-blob-3" />
            </div>
            <GrainOverlay intensity={0.15} />

            {/* Hero content */}
            <motion.div
                className="hero-content"
                variants={staggerContainer(0.12, 0.3)}
                initial="hidden"
                animate="visible"
            >
                <motion.h1 className="hero-name" variants={fadeUp}>
                    Shivani Visen
                </motion.h1>

                <motion.p className="hero-subtitle" variants={fadeUp}>
                    Design Leader
                </motion.p>

                <motion.span className="hero-location" variants={fadeUp}>
                    🇨🇭 Based in Switzerland
                </motion.span>

                <motion.div className="hero-ctas" variants={fadeUp}>
                    <button className="cta-primary" onClick={scrollToWork}>
                        View Work
                    </button>
                </motion.div>
            </motion.div>

            {/* Companies section */}
            <motion.div
                className="hero-companies"
                variants={fadeIn}
                initial="hidden"
                animate="visible"
                transition={{ delay: 0.8 }}
            >
                <span className="companies-label">
                    Trusted by teams at
                </span>
                <Companies />
            </motion.div>

            {/* Scroll indicator */}
            <div className="scroll-indicator" onClick={scrollToWork}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
        </section>
    );
};

export default AboutMe;
